import dc from "@/component/DataChk.js";
import dayjs from "dayjs";
import { reactive } from "vue";

export default {
    // 시간 데이터
    timeOptions: reactive([
        { value: null, text: "전체" },
        { value: 0, text: "00시" },
        { value: 1, text: "01시" },
        { value: 2, text: "02시" },
        { value: 3, text: "03시" },
        { value: 4, text: "04시" },
        { value: 5, text: "05시" },
        { value: 6, text: "06시" },
        { value: 7, text: "07시" },
        { value: 8, text: "08시" },
        { value: 9, text: "09시" },
        { value: 10, text: "10시" },
        { value: 11, text: "11시" },
        { value: 12, text: "12시" },
        { value: 13, text: "13시" },
        { value: 14, text: "14시" },
        { value: 15, text: "15시" },
        { value: 16, text: "16시" },
        { value: 17, text: "17시" },
        { value: 18, text: "18시" },
        { value: 19, text: "19시" },
        { value: 20, text: "20시" },
        { value: 21, text: "21시" },
        { value: 22, text: "22시" },
        { value: 23, text: "23시" },
    ]),

    // 날짜(ex: 2025-02-06) + 시간(ex: 23) 병합
    mergeStartDateTime(date, time) {
        const mergeDate = new Date(date);
        mergeDate.setHours(time, 0, 0, 0);
        return mergeDate;
    },
    mergeEndDateTime(date, time) {
        const mergeDate = new Date(date);
        if (time !== null) {
            mergeDate.setHours(time + 1, 0, 0, 0);
        } else {
            mergeDate.setDate(mergeDate.getDate() + 1);
            mergeDate.setHours(0, 0, 0, 0);
        }
        return mergeDate;
    },

    // 날짜시간 포맷
    dateTimeFormat(date) {
        if (!dc.nullChk(date)) {
            return "-";
        }
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    },

    // 내보내기 포맷
    dateFormatWithTime(date) {
        if (!dc.nullChk(date)) {
            return "-";
        }
        return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.00");
    },

    // 날짜 포멧
    dateFormat(date) {
        if (!dc.nullChk(date)) {
            return "-";
        }
        return dayjs(date).format("YYYY-MM-DD");
    },

    // ObjectID 시간 변환
    datetimeFromObjectId(data) {
        if (!dc.nullChk(data)) {
            return "-";
        }
        return this.dateTimeFormat(new Date(parseInt(data.substring(0, 8), 16) * 1000));
    },

    dateFromObjectId(objectId) {
        if (!objectId || typeof objectId !== "string" || objectId.length < 8) return "";

        const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;
        const date = new Date(timestamp);
        return this.dateFormat(date);
    },

    // 날짜 차이 계산
    checkDiffDate(startDate, endDate, month) {
        const sDate = dayjs(startDate);
        const eDate = dayjs(endDate);

        const result = eDate.diff(sDate, "month", true);

        if (result > month) {
            return false;
        } else {
            return true;
        }
    },
};
